<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records upload-dna-section">
            <div class="row h-100">
                <div class="col-12 mb-4 h-100">
                    <div class="bg-white border-radius-5 p-3 h-100">
                        <div class="row justify-content-center p-md-4">
                            <div class="col-lg-7 text-center">
                                <h2 class="mb-3">Securely upload your DNA test</h2>
                                <p>We support 23andMe, AncestryDNA and MyHeritage files. If your data is from a different company we'll try our best to read the information.</p>
                                <p>We prefer .TXT files. If you encounter a problem uploading your zip file, please extract the zip and try again with the text file.</p>
                                <form class="mt-5">
                                    <div class="drag-drop d-flex justify-content-between mb-4">
                                        <input type="file" multiple />
                                        <p class="mb-0">Upload your DNA</p>
                                        <i class="icon icon-upload-reports"></i>
                                    </div>
                                    <button type="submit" class="btn btn-blue">Finish</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "connect-dna-data",
        data() {
            return {};
        },
        created(){
           this.pageName('Test/Reports')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/dna/connect-dna-data.vue